/* eslint-disable */
import React, { useEffect, useReducer, useState, useRef } from "react";
import RequestsCard from "components/RequestsCard";
import api from "api";
import getEsriData from "context/contextFunctions/getEsriData";
import { useEsriUrls } from "context/esriUrlsContext";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import PrintParcels from "components/PrintParcels";
import Dialog from "components/Dialog/Dialog";
import { Link, useLocation } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useAuth } from "context/auth";
import joinVillsAndHodsIntoData from "utils/selfUtils/joinVillsAndHodsIntoData";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function PeopleRequests() {
  const [map] = useMap();
  const [, dispatchLoading] = useLoading();
  const [auth] = useAuth();

  const { view } = map;
  const [esriUrls] = useEsriUrls();
  const [lands, setLands] = useState(null);
  const [allLands, setAllLands] = useState(null);
  const [hods, setHods] = useState(null);
  const hodInput = useRef(null);
  const [PaymentDetail, setPaymentDetail] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const yourQueryValue = queryParams.get("Query");

  // Reference to the element to scroll to
  const scrollToRef = useRef(null);

  const [printData, setPrintData] = useState(null);
  const [printDialogState, printDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  const togglePrintDialog = (data) => {
    printDispatchDialog({ type: "TOGGLE" });
    if (data) setPrintData(data);
  };

  const getUserPayments = async () => {
    try {
      handleLoading(dispatchLoading, true);

      const paymentRes = await api.get("/payment");
      function convertToKeyedObject(array) {
        return array.reduce((acc, item) => {
          acc[item.dlsKey.trim()] = item;
          return acc;
        }, {});
      }
      setPaymentDetail(convertToKeyedObject(paymentRes.data.data.list));
      const tempPayments = paymentRes.data.data.list.map((item) => ({
        ...item,
        dlsKey: item.dlsKey.trim(),
      }));

      const paymentDlsKeys = tempPayments.map((item) => `'${item.dlsKey}'`);
      const landsQuery = `DLS_KEY IN (${paymentDlsKeys})`;
      const { res: landsEsriRes } = await getEsriData({
        view,
        token: auth.esriToken,
        layerId: esriUrls.DLSParcelsLayer,
        layer: process.env.REACT_APP_DLSParcelsLayer_Table,
        query: landsQuery,
        featureOrMap: "MapServer",
      });
      const { res: landsEsriResWithNames } = await joinVillsAndHodsIntoData({
        data: landsEsriRes,
        esriToken: auth.esriToken,
        villLayerId: esriUrls.villagesLookup,
        hodLayerId: esriUrls.hodesLookUp,
      });
      const landsWithPaymentData = landsEsriResWithNames
        .map((item) => ({
          ...item,
          ...tempPayments.find(
            (paymentItem) => paymentItem.dlsKey === item.DLS_KEY
          ),
        }))
        .sort((a, b) => Date.parse(b.requestDate) - Date.parse(a.requestDate));

      setLands(landsWithPaymentData);
      const hodsList = landsWithPaymentData.map((item) => item.HOD_ANAME);
      setHods([...new Set(hodsList)]);
      setAllLands(landsWithPaymentData);
    } catch (error) {
      ErrorHandelFunctionApp(error);
    }
    handleLoading(dispatchLoading, false);
  };

  useEffect(() => {
    (async () => {
      if (esriUrls.Parcels_Intersect) {
        await getUserPayments();
      }
    })();
  }, [esriUrls]);

  const handleFilterChange = () => {
    if (!allLands) return;
    const hodValue = hodInput.current.value;
    const filteredLands = allLands.filter((land) => {
      if (!hodValue) return true;
      return land.HOD_ANAME == hodValue;
    });
    setLands(filteredLands);
  };

  useEffect(() => {
    if (lands && yourQueryValue) {
      const targetItem = lands.find((item) => Number(item.ePaymentNumber) === Number(yourQueryValue));
      if (targetItem && scrollToRef.current) {
        scrollToRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [lands, yourQueryValue]);

  return (
    <>
      <h2 className="content__title title mt-3">طلباتي</h2>
      <div
        className="lands_filter"
        style={{ display: "grid", gap: "1rem", marginBottom: "1rem" }}
      >
        <div>
          <Form.Label>الحوض</Form.Label>
          <Form.Select
            defaultValue=""
            onChange={handleFilterChange}
            ref={hodInput}
          >
            <option value="">ادخل الحقل للتصفية</option>
            {hods?.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      <div>
        {lands &&
          lands.map((item) => (
            <div
              key={item.dlsKey}
              ref={item.ePaymentNumber === yourQueryValue ? scrollToRef : null}
              style={{marginTop: "1rem"}}>
              <RequestsCard
                PaymentDetail={PaymentDetail}
                data={item}
                activeShadow={item.ePaymentNumber === yourQueryValue}
                toggleDialog={togglePrintDialog}
              />
            </div>
          ))}
        {!lands && (
          <p className="text-center">
            لا يوجد طلبات لعرضها حاليا يمكنك إضافة طلب طباعة من{" "}
            <Link to="/myrequests" className="text-underline">
              الأراضي الخاصة بي
            </Link>
          </p>
        )}
      </div>
      <Dialog
        state={printDialogState}
        dispatch={printDispatchDialog}
        footer={false}
        title="تحديد مقياس الرسم لمخطط الموقع"
        closeButton
        centered
      >
        <PrintParcels isPrivateOfficialWork={1} printData={printData} toggleDialog={togglePrintDialog} />
      </Dialog>
    </>
  );
}

export default PeopleRequests;
